import OutlineButton from "components/Button/OutlineButton";
import { Flex } from "@chakra-ui/react";
import colors from "core/resources/theme/colors";
import { AiFillPrinter } from "react-icons/ai";

interface ButtonImprimirProps {
  onClick: () => any;
}

function ButtonImprimir({ onClick }: ButtonImprimirProps) {
  return (
    <OutlineButton
      p={0}
      w="100%"
      justifyContent="start"
      border="none"
      onClick={onClick}
    >
      <Flex w={"16px"} mr={-1}>
        <AiFillPrinter color={colors.primary} size={34} />
      </Flex>
      Imprimir
    </OutlineButton>
  );
}

export default ButtonImprimir;
